import { atom } from 'jotai';

// Store open state for dropdowns (persists across re-renders)
// Map key format: "nodeId-statementIndex-criteriaIndex-type" where type is "condition" or "response" or "operator"
export const dropdownOpenStateAtom = atom<Map<string, boolean>>(new Map());

// LF360-1933: allDropdownsLockedAtom and globalStabilityIntervalAtom lived here
// until BRM-03. The first held one boolean per node that gated a panel-wide
// loading overlay; the second held that node's stability-checker interval id.
// Both are gone, not renamed: the pending state they backed is now per-row and
// component-local in BehaviorRulesNodeInfo.tsx, and an interval id is a ref.
// Neither was public API - src/index.ts exports only Editor, detectChange and
// ErrorBoundary - so nothing outside this package could have been reading them.
